import Icon from 'veui/components/Icon'

Icon.register({
  'file-cny': {
    paths: [
      {
        d: 'M352 416v-64h-96a32 32 0 010-64h19.6l-18-53.88a32 32 0 0160.72-20.24L343.06 288h81.88l24.7-74.12a32 32 0 0160.72 20.24L492.4 288H512a32 32 0 010 64h-96v64h96a32 32 0 010 64h-96v64a32 32 0 01-64 0v-64h-96a32 32 0 010-64zM672 64v640a32 32 0 01-32 32H128a32 32 0 01-32-32V64a32 32 0 0132-32h512a32 32 0 0132 32zm-64 32H160v576h448z'
      }
    ],
    width: '768',
    height: '768'
  }
})
